import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { VideoCard } from "@/components/VideoCard";
import { Loader2 } from "lucide-react";

export default function Home() {
  const [videos, setVideos] = useState(null);

  useEffect(() => {
    api.get("/videos").then((r) => setVideos(r.data)).catch(() => setVideos([]));
  }, []);

  return (
    <div className="bg-luxe min-h-screen">
      <Header />
      <section className="max-w-7xl mx-auto px-6 lg:px-10 pt-36 lg:pt-44 pb-16 text-center">
        <img src="/amg-logo.jpg" alt="Art Money Group" className="h-[115px] w-[115px] mx-auto object-contain invert mix-blend-screen mb-8" />
        <h1 className="font-display text-[clamp(0.9rem,3.8vw,3.75rem)] tracking-tight text-[#F5F3EE] leading-tight whitespace-nowrap">
          Une expérience présentée par <span className="text-[#D4AF37]">Art Money Group</span>
        </h1>
      </section>

      <section id="catalogue" className="max-w-7xl mx-auto px-6 lg:px-10 pb-16">
        <div className="flex items-baseline gap-4 mb-10">
          <h2 className="font-display text-2xl text-[#F5F3EE]">Catalogue</h2>
          <span className="h-px flex-1 bg-black/10" />
          {videos && videos.length > 0 && (
            <span className="text-sm text-[#8F8F8F]">
              {videos.length} {videos.length > 1 ? "vidéos disponibles" : "vidéo disponible"}
            </span>
          )}
        </div>

        {!videos ? (
          <div className="flex justify-center py-24">
            <Loader2 className="w-8 h-8 animate-spin text-[#D4AF37]" />
          </div>
        ) : videos.length === 0 ? (
          <p data-testid="empty-catalogue" className="text-center text-[#8F8F8F] py-24">
            Aucune vidéo disponible pour le moment. Revenez bientôt.
          </p>
        ) : (
          <div data-testid="video-grid" className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {videos.map((v) => (
              <VideoCard key={v.id} video={v} />
            ))}
          </div>
        )}
      </section>
      <Footer />
    </div>
  );
}
